import { render } from "./Beer.vue?vue&type=template&id=106b7dfe"
import script from "./Beer.vue?vue&type=script&lang=js"
export * from "./Beer.vue?vue&type=script&lang=js"
script.render = render

export default script